import StudentPendingActivationModal from './StudentPendingActivationModal';

export default StudentPendingActivationModal;
